import { ColumnProps } from 'antd/lib/table'

// get object nested props from path string
const getPropFromPath = (startObj, path: string) => {
  return path.split('.').reduce(function (p, prop) {
    return p[prop]
  }, startObj)
}

// return true if column is empty or if it is not in dataSource
export const isColumnEmpty = (column: ColumnProps<unknown>, dataSource: unknown[]): boolean => {
  return dataSource.every((row) => {
    if (!column.dataIndex) return true
    const value = getPropFromPath(row, column.dataIndex)
    return value === null || value === undefined || value === ''
  })
}
